export default __webpack_public_path__ + "img/eZJpnGHL.3f027414.svg";